import { Skeleton } from "@/components/ui/skeleton";

interface UserSettiingsSkeletonProps {
  showTabs?: string;
}
const UserSettiingsSkeleton = ({ showTabs }: UserSettiingsSkeletonProps) => {
  return (
    <div className="space-y-6">
      {/* Tabs Header Skeleton */}
      {showTabs && (
        <div className="grid grid-cols-2 lg:grid-cols-3 w-full bg-gray-100 p-1 rounded-lg gap-2">
          <Skeleton className="h-10 rounded-md" />
          <Skeleton className="h-10 rounded-md" />
          <Skeleton className="h-10 rounded-md hidden lg:block" />
        </div>
      )}

      {/* Form Content Skeleton */}
      <div className="space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24 rounded" />
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-32 rounded" />
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-20 rounded" />
          <Skeleton className="h-10 w-full rounded-md" />
        </div>
      </div>

      {/* Buttons Skeleton */}
      <div className="flex justify-end gap-2 pt-4">
        <Skeleton className="h-10 w-24 rounded-md" />
        <Skeleton className="h-10 w-32 rounded-md" />
      </div>
    </div>
  );
};

export default UserSettiingsSkeleton;
